<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <template v-html="webView"></template>
      </div>

      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';

export default {
  name: 'guestOrderNotice',
  components: {
    QuickMenu,
  },
  data() {
    return {
      headerTitle: '유의사항',

      webViews: [],
      webView: null,
    };
  },
  mounted() {
    this.selectCommonWebViewList();
  },
  methods: {
    selectCommonWebViewList() {
      ApiService.service('GET', '/common/webView/WB000005', '')
        .then(({ data }) => {
          console.log(data);
          this.webViews = data.result;
          this.selectWebView();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectWebView() {
      ApiService.service('GET', tthis.webViews[0].filePath)
        .then(({ data }) => {
          console.log(data);
          this.webView = data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
